import { ExternalLink, X } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";

import { ClientContactLines, ClientPanelBody } from "../ClientSheet";
import { ClientStageBar } from "../ClientStageBar";
import { fullName, type GulaClient } from "../gulaTypes";

/**
 * The client panel docked next to the call list in Mi jornada, so the setter
 * fills in the call without leaving the page.
 */
export const ClientSidePanel = ({
  client,
  onClose,
  onChanged,
}: {
  client: GulaClient;
  onClose: () => void;
  onChanged: () => void;
}) => (
  <aside className="flex flex-col overflow-hidden rounded-3xl border bg-background shadow-sm lg:sticky lg:top-4 lg:max-h-[calc(100vh-2rem)]">
    <div className="flex items-start gap-2 border-b bg-muted/40 px-4 py-3">
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
          Ficha
        </span>
        <h2 className="truncate text-xl font-semibold leading-tight">
          {fullName(client)}
        </h2>
        <ClientContactLines client={client} />
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <Button
          asChild
          variant="ghost"
          size="icon"
          className="rounded-full"
          title="Abrir en Clientes"
        >
          <Link to={`/clientes?cliente=${client.id}`}>
            <ExternalLink className="h-4 w-4" />
          </Link>
        </Button>
        <Button
          variant="ghost"
          size="icon"
          className="rounded-full"
          onClick={onClose}
          title="Cerrar ficha"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
    <div className="flex flex-col gap-5 overflow-y-auto pt-4">
      <div className="px-4">
        <ClientStageBar client={client} onChanged={onChanged} />
      </div>
      <ClientPanelBody
        key={String(client.id)}
        client={client}
        onSaved={onChanged}
      />
    </div>
  </aside>
);
